import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DimensionEffects } from './dimension/dimension.effects';
import * as fromDimension from './dimension/dimension.reducer';
import { MetricFacade } from './metric.facade';
import { MetricEffects } from './metric/metric.effects';
import * as fromMetric from './metric/metric.reducer';

@NgModule({
  imports: [
    CommonModule,
    SharedDataAccessWebappModule,
    SharedUtilDomModule,
    StoreModule.forFeature(fromMetric.metricFeatureKey, fromMetric.reducer),
    StoreModule.forFeature(fromDimension.dimensionFeatureKey, fromDimension.reducer),
    EffectsModule.forFeature([MetricEffects, DimensionEffects]),
  ],
  providers: [MetricFacade],
})
export class MetricsDomainModule {}
